import moment from "moment";

export const getTimeAddHourCurrentTime = async (hours: number = 0) => {
    const currentDateCustom = new Date();
    return moment.utc(currentDateCustom).local().add(hours, 'hours').format('HH:mm');
}
